module.exports = __webpack_public_path__ + "static/media/208-Arzt_ID_27.0c96b5df.mp3";